import { render } from "./ArrowBooks.vue?vue&type=template&id=20928020"
import script from "./ArrowBooks.vue?vue&type=script&lang=js"
export * from "./ArrowBooks.vue?vue&type=script&lang=js"

import "./ArrowBooks.vue?vue&type=style&index=0&id=20928020&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__